import React, { useState, useEffect } from "react";
import HeadingBanner from "../components/HeadingBanner";
import Login from "../components/Login";
import RightPanel from "../components/RightPanel";
import { Container, Row, Col } from "react-bootstrap";
import SignUpForm from "../components/SignUpForm";
import OrientationPrompt from "../components/OrientationPrompt";

import "../components/RightPanel.css";
import "../components/Login.css";

function App(props) {
  const [isPortrait, setIsPortrait] = useState(
    window.matchMedia("(orientation: portrait)").matches
  );

  useEffect(() => {
    const handleOrientationChange = () => {
      setIsPortrait(window.innerWidth < window.innerHeight);
    };

    window.addEventListener("resize", handleOrientationChange);

    return () => {
      window.removeEventListener("resize", handleOrientationChange);
    };
  }, []);

  return (
    <Container fluid className="vh-100 d-flex flex-column">
      <HeadingBanner
        isLoggedIn={false}
        cloud={true}
        name={"Assessing Letter & Phonemic Awareness Class Assistant"}
      />
      <Row className="h-100">
        <Col sm={8}>
          <Login />
          {/* <div style={{ textAlign: 'center', marginTop: '20%', fontFamily: 'Arial, sans-serif', border: "1px solid black"}}>
            <h2 style={{ color: '#2c3e50' }}>The platform will be live and ready for screening on Monday, September 1st.</h2>
            <h3 style={{ color: '#7f8c8d' }}>If you mix up your Juniors when creating your Senior Infant classrooms, 
              just email us your senior infant class lists and classroom teacher names at info@alpaca-assessment.com and we'll create the senior infant classrooms for you.
            </h3>
            <h3 style={{ color: '#16a085' }}>We will be back fully open on <strong>09:00 AM on September 1st, 2025</strong>.  </h3>
            <h3 style={{ color: '#7f8c8d' }}>Thank you for your understanding and patience.</h3>
          </div> */}
          {/* <div style={{
            textAlign: 'center',
            // marginTop: '20%',
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            // padding: '40px',
            maxWidth: '80%',
            margin: '20% auto 0'
          }}>
            <h2 style={{
              color: '#000000',
              marginBottom: '30px',
              fontWeight: '500',
              fontSize: '1.8rem'
            }}>
              The platform will be live and ready from Monday, September 1st.
            </h2>
            <h2 style={{
              color: '#000000',
              marginBottom: '30px',
              fontWeight: '500',
              fontSize: '1.8rem'
            }}>
              Screening opens from Monday 8th September.
            </h2>
            <h2 style={{
              color: '#000000',
              marginBottom: '30px',
              fontWeight: '500',
              fontSize: '1.8rem'
            }}>
              Any queries, please email <strong style={{ color: '#0056b3' }}>info@alpaca-assessment.com</strong>.
            </h2> */}

            {/* <div style={{
              backgroundColor: '#f8f9fa',
              borderLeft: '4px solid #4ecdc4',
              padding: '25px',
              borderRadius: '0 10px 10px 0',
              margin: '30px 0',
              textAlign: 'left'
            }}>
              <p style={{
                color: '#555',
                lineHeight: '1.6',
                margin: '0',
                fontSize: '1rem'
              }}>
                We’ll create Senior Infant classrooms by moving last year’s Juniors to Seniors, in the same groups.
                If groups have changed, email ALL Senior Infant class lists and their teacher names to <strong style={{ color: '#0056b3' }}>info@alpaca-assessment.com</strong> and we'll create the Senior Infant classrooms for you. 
                Please allow 48 hours for this to happen. */}
                {/* If you mix up your Juniors when creating your Senior Infant classrooms,
                just email us your senior infant class lists and classroom teacher names at{' '}
                <strong style={{ color: '#0056b3' }}>info@alpaca-assessment.com</strong>{' '}
                and we'll create the senior infant classrooms for you. */}
              {/* </p>
            </div>

            <h3 style={{
              color: '#000000',
              fontStyle: 'italic',
              fontWeight: '400',
              fontSize: '1.2rem'
            }}>
              Looking forward to seeing you back soon!
            </h3> */}
          {/* </div> */}
        </Col>
        <RightPanel
          msg="Thinking of using ALPACA in your school, check us out on alpaca-assessment.com"
          label="Alpaca Assessment"
          path="https://www.alpaca-assessment.com/"
        />
      </Row>
      {isPortrait && <OrientationPrompt />}{" "}
      {/* Render OrientationPrompt based on isPortrait */}
    </Container>
  );
}

export default App;
